/* unplugin-vue-components disabled */import { render } from "./SettingsPaymentMethods.vue?vue&type=template&id=8697bc9e&ts=true"
import script from "./SettingsPaymentMethods.vue?vue&type=script&lang=ts"
export * from "./SettingsPaymentMethods.vue?vue&type=script&lang=ts"

import "./SettingsPaymentMethods.vue?vue&type=style&index=0&id=8697bc9e&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__